import React from 'react';
import PropTypes from 'prop-types';

import { defineMessages, injectIntl } from 'gatsby-plugin-react-intl';
import { formatPrice } from '@utils/formatting';
import { intlShape } from '@prospectus/common/types/intlShape';

import { currencyInfoShape } from '@prospectus/common/types/allCurrencyShape';

const messages = defineMessages({
  'prospectus.course.snapshot.price.cost': {
    id: 'prospectus.course.snapshot.price.cost',
    defaultMessage: 'Cost to Enroll',
    description: 'Heading for the course price',
  },
});

function PaidLanguage({
  intl,
  coursePrice,
  userCurrency,
}) {
  return (
    <>
      <div className="h4 mb-0">
        {intl.formatMessage(messages['prospectus.course.snapshot.price.cost'])}
      </div>
      <div className="small">
        {formatPrice(coursePrice, userCurrency, intl)}
      </div>
    </>
  );
}

PaidLanguage.propTypes = {
  coursePrice: PropTypes.string.isRequired,
  userCurrency: currencyInfoShape.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(PaidLanguage);
